import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BikeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4 11.5C4.82843 11.5 5.5 10.8284 5.5 10C5.5 9.17157 4.82843 8.5 4 8.5C3.17157 8.5 2.5 9.17157 2.5 10C2.5 10.8284 3.17157 11.5 4 11.5ZM4 13C5.65685 13 7 11.6569 7 10C7 8.34315 5.65685 7 4 7C2.34315 7 1 8.34315 1 10C1 11.6569 2.34315 13 4 13Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.1716 8.5 10.5 9.17157 10.5 10C10.5 10.8284 11.1716 11.5 12 11.5ZM12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.32138 5.43065C5.44508 5.16778 5.70947 5 5.99999 5H11C11.4142 5 11.75 5.33579 11.75 5.75C11.75 6.21314 11.7973 7.03071 11.9382 7.81778C12.0086 8.21083 12.0992 8.5776 12.2104 8.88078C12.326 9.19598 12.4422 9.38157 12.5303 9.46967C12.8232 9.76256 12.8232 10.2374 12.5303 10.5303C12.2374 10.8232 11.7626 10.8232 11.4697 10.5303C11.1578 10.2184 10.949 9.79777 10.8021 9.39734C10.6508 8.9849 10.5413 8.52667 10.4617 8.08222C10.3631 7.53126 10.3053 6.97279 10.2757 6.5H6.47595L4.67861 10.3193C4.50224 10.6941 4.05543 10.855 3.68065 10.6786C3.30586 10.5022 3.14501 10.0554 3.32138 9.68065L5.32138 5.43065Z"
		/>
		<path
			fill="currentColor"
			d="M4 3.75C4 3.33579 4.33579 3 4.75 3H5.125C6.16053 3 7 3.83947 7 4.875V5H5.25C4.55964 5 4 4.44036 4 3.75Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.75 2.75C8.75 2.33579 9.08579 2 9.5 2H10.3344C11.4069 2 12.2271 2.95602 12.064 4.0161L11.7413 6.11404C11.6783 6.52344 11.2954 6.80426 10.886 6.74128C10.4766 6.67829 10.1957 6.29535 10.2587 5.88596L10.5815 3.78801C10.6048 3.63657 10.4876 3.5 10.3344 3.5H9.5C9.08579 3.5 8.75 3.16421 8.75 2.75Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.6431 5.61413C11.8562 5.96932 11.741 6.43002 11.3859 6.64313L6.38586 9.64313C6.03068 9.85624 5.56998 9.74106 5.35687 9.38588C5.14376 9.03069 5.25893 8.57 5.61412 8.35689L10.6141 5.35689C10.9693 5.14378 11.43 5.25895 11.6431 5.61413Z"
		/>
	</svg>
))
